var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('div',{staticClass:"main-content"},[_c('Banner'),_c('BrandCatalogue'),_c('LatestShipments'),_c('HelpBanner'),_c('PopularProducts'),_c('ServiceWorkflow')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }